import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';
import { SettingsService } from '../common/settings.service';
import Enums from '../../utils/enums';

@Injectable()
export class LoginGuardService {

	constructor(private authService: AuthService,
		private router: Router,
		private settingsService: SettingsService
	) { }

	canActivate() {
		let role: string = this.authService.getUserLoginRole();

		if (this.authService.getUserToken()) {
			if (role == this.settingsService.LOGIN_ROLE(Enums.eRole.Administrator) || role == this.settingsService.LOGIN_ROLE(Enums.eRole.SuperAdministrator)) {
				this.router.navigate(['dashboard']);
				return false;
			} else if (role == this.settingsService.LOGIN_ROLE(Enums.eRole.Police)) {
				this.router.navigate(['vehicle-checks']);
				return false;
			} else if (role == this.settingsService.LOGIN_ROLE(Enums.eRole.EveHandler)) {
				this.router.navigate(['eve']);
				return false;
			}
		} else {
			return true;
		}
	}
}
